import React from 'react';
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import { useTranslation } from 'react-i18next';
import { messageService } from '../../../services/messageService';

const CommandBarRight = () => {
  const { t } = useTranslation();
  const newClick = () => {
    messageService.sendMessage({ isNewStock: true });
    // props.createNew(true);
  };
  const saveFormData = () => {
    messageService.sendMessage({ saveStockData: true });
  };
  const handleRemove = () => {
    // props.handleRemove();
  };

  const handlePmolApprove = () => {
    messageService.sendMessage({ approvePmol: true });
  };

  const getItems = () => {
    return [
      {
        key: 'new',
        text: t('new'),
        iconProps: { iconName: 'Add' },
        onClick: () => {
          newClick();
        },
        disabled: false,
      },
      {
        key: 'save',
        text: t('save'),
        iconProps: { iconName: 'Save' },
        onClick: () => {
          saveFormData();
        },
        disabled: false,
      },
      // {
      //     key: 'print',
      //     onClick: () => {handleRemove();},
      //     name: t('remove'),
      //     iconProps: { iconName: 'Delete' },
      //     disabled: true
      // },
      // {
      //     key: 'approve',
      //     text: t('approve'),
      //     iconProps: { iconName: 'ActivateOrders' },
      //     disabled: false,
      //     onClick: () => handlePmolApprove()
      // }
    ];
  };

  return (
    <div>
      <CommandBar
        items={getItems()}
        ariaLabel="Use left and right arrow keys to navigate between commands"
      />
    </div>
  );
};

export default CommandBarRight;
